import intl from 'react-intl-universal';
import { useState } from 'react';
import { Dropdown, message } from 'antd';
import Login from './login';

import { getLoginToken } from '@/api/softPhone';

interface Props {
    currentStatus: string;
    jobNumber: string;
    isLogin: boolean;
    pauseStatus: any[];
    onLogin?: () => void;
    onStateChange?: MenuClickEventHandler;
}

import style from '../index.less';

const ChangeStatus: React.FC<Props> = ({
    currentStatus,
    isLogin,
    pauseStatus,
    jobNumber,
    onLogin: onLoginProps,
    onStateChange,
}) => {
    const [showLoginConfig, setShowLoginConfig] = useState<boolean>(false);

    const onLoginClick = () => {
        setShowLoginConfig(true);
    };

    const onLogin = (params) => {
        return getLoginToken(jobNumber).then((res) => {
            window.softPhoneUtils
                ?.login({
                    ...params,
                    cno: jobNumber,
                    agentTokenLogin: 1,
                    agentToken: res.data,
                    loginStatus: params.loginStatus === 1 ? 1 : 2,
                    pauseDescription:
                        params.loginStatus === 1 ? '' : params.loginStatus,
                })
                .catch((res) => {
                    message.error(res.msg);
                    return Promise.reject();
                })
                .then(() => {
                    setShowLoginConfig(false);
                    onLoginProps?.(params);
                });
        });
    };

    return (
        <>
            {isLogin ? (
                <Dropdown
                    menu={{
                        items: [
                            currentStatus !== intl.get('空闲') && {
                                key: intl.get('空闲'),
                                label: intl.get('空闲'),
                            },
                            ...pauseStatus
                                .filter((item) => item.pauseStatus !== status)
                                .map((item) => ({
                                    key: item.pauseStatus,
                                    label: <span>{item.pauseStatus}</span>,
                                })),
                            {
                                key: intl.get('签出'),
                                label: intl.get('签出'),
                            },
                        ].filter((item) => !!item),
                        selectable: true,
                        defaultSelectedKeys: [status],
                        onClick: onStateChange,
                    }}
                    arrow={true}
                >
                    <div
                        className={`${style.status} ${
                            currentStatus === intl.get('空闲')
                                ? style.green
                                : style.red
                        }`}
                    >
                        {currentStatus}
                    </div>
                </Dropdown>
            ) : (
                <div
                    className={style.status}
                    onClick={onLoginClick}
                >
                    {intl.get('签入')}
                </div>
            )}

            <Login
                onLogin={onLogin}
                show={showLoginConfig}
                pauseStatus={pauseStatus}
                onClose={() => setShowLoginConfig(false)}
            />
        </>
    );
};

export default ChangeStatus;
